export const rolesListColums = [
  {
    name: "Nombre",
    selector: (row) => row["name"],
    sortable: true,
    center: false,
  },
];
